import { render, staticRenderFns } from "./SubComponent.vue?vue&type=template&id=1573a4d0&scoped=true"
import script from "./SubComponent.vue?vue&type=script&lang=js"
export * from "./SubComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573a4d0",
  null
  
)

export default component.exports